import { lazy, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { type UiBlock, uiBlockSchema } from '../../../data-contract/chat';
import { toJsonRenderSpec } from '../../generative-ui/to-json-render-spec';
import type { ActivityRenderer } from './types';

const GenerativeUiCard = lazy(async () => {
    const { GenerativeUiCard } = await import('../../generative-ui/GenerativeUiCard');

    return { default: GenerativeUiCard };
});

export const uiBlockRenderer: ActivityRenderer<UiBlock> = {
    renderInline: (content) => (
        <ErrorBoundary fallback={null}>
            <Suspense fallback={null}>
                <GenerativeUiCard blockId={content.blockId} spec={content.spec} />
            </Suspense>
        </ErrorBoundary>
    ),
    rendersInlineContent: (content) => toJsonRenderSpec(content.spec).isValid,
    schema: uiBlockSchema,
};
